<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <!--<iframe style="width: 100%;height: calc(100vh - 200px)" width="680"-->
    <!--src="https://app.powerbi.com/reportEmbed?reportId=441fd05b-db3b-4f58-9211-7ef96327f6b3&autoAuth=true&ctid=b44c5526-eed6-4d77-8e62-eafcec7e2a2d&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXNvdXRoLWVhc3QtYXNpYS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCJ9"-->
    <!---->
    <!--frameborder="0" allowFullScreen="true">-->

    <!--</iframe>-->
    <div id="fullscreen" style="width: 100%; height: 100%">
      <vs-button
        :class="checkActive(list.report.param) ? 'tbl-active' : 'tbl-none'"
        color="primary"
        style="padding: 7px; font-size: 12px; margin: 5px"
        @click="gantiPage(list.report.param)"
        v-for="(list, index) in tabReport"
        :key="index"
        >{{ list.report.label }}
      </vs-button>
      <div
        style="width: 100%; height: calc(100vh - 53px)"
        id="embedContainer"></div>
    </div>

    <!--<div>-->
    <!--<vs-button type="gradient" class="mt-2 shadow-lg" color="#d23030"-->
    <!--gradient-color-secondary="#f89595" @click="fullscreen2()">View FullScreen-->
    <!--</vs-button>-->
    <!--</div>-->
    <div
      style="
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: #ffffffc4;
      ">
      <vs-button
        type="gradient"
        class="mt-2 shadow-lg"
        color="#d23030"
        style="
          position: absolute;
          background: linear-gradient(
            30deg,
            rgb(46, 49, 146) 0%,
            rgb(0, 174, 239) 100%
          );
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
        gradient-color-secondary="#f89595"
        @click="fullscreen2()"
        >View FullScreen
      </vs-button>
    </div>

    <!--<div style="position:absolute; height:100%; width:100%; border: none" id="embedContainer"></div>-->
  </div>
</template>

<script>
import * as REPO from '../../repository/index'
import * as pbi from 'powerbi-client'
import * as cron from 'node-cron'

import axios from 'axios'
import { GET_PARAM_POWER_BY } from '../../constant'

export default {
  data() {
    return {
      report: null,
      crontab: '',
      aktifBtn: '',
      tabReport: '',
      isFuelConsumption: 0,
      fleet_group_id: '',
      data: '',
    }
  },
  beforeDestroy() {
    this.stopCron()
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
  methods: {
    checkActive(val) {
      return this.aktifBtn == val
    },
    gantiPage(val) {
      this.aktifBtn = val
      const page = this.report.page(val)
      page.setActive()
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + x.fleet_group_name
        let tmp = {
          text: x.fleet_group_name,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    fullscreenChange() {
      if (
        document.fullscreenEnabled ||
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement
      ) {
        //
      } else {
        //
      }
      // force to reload iframe once to prevent the iframe source didn't care about trying to resize the window
      // comment this line and you will see
      var iframe = document.querySelector('#fullscreen')
      iframe.src = iframe.src
    },
    stopCron() {
      if (this.crontab !== null) this.crontab.stop()
      // this.$crontab.stopCrontab({name: "counter"});
    },
    fullscreen2() {
      // check if fullscreen mode is available
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        // which element will be fullscreen
        var iframe = document.querySelector('#fullscreen')
        // Do fullscreen
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen()
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen()
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen()
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen()
        }
      } else {
        document.querySelector('.error').innerHTML =
          'Your browser is not supported'
      }
    },
  },
  created() {
    let self = this
  },
  mounted() {
    var self = this
    this.crontab = cron.schedule(
      ' */10 * * * *',
      () => {
        REPO.refreshToken().then((result) => {
          let payload = {
            expired_date: result.data.data.expired_date,
            token: result.data.data.token,
          }
          self.$store.dispatch('auth/reloadStorage', payload)
        })
      },
      {
        scheduled: true,
      }
    )

    this.crontab.start()
    self.fullscreen2()
    // Read embed application token from textbox
    this.fleet_group_id = this.$dataLocal.UserData().fleet_group_id
    this.isFuelConsumption =
      this.$dataLocal.UserData().fleet_group.is_fuel_consumption
    document.addEventListener('keydown', function (e) {
      //
    })
    document.addEventListener('webkitfullscreenchange', this.fullscreenChange)
    document.addEventListener('mozfullscreenchange', this.fullscreenChange)
    document.addEventListener('fullscreenchange', this.fullscreenChange)
    document.addEventListener('MSFullscreenChange', this.fullscreenChange)
    this.fleet_group_id = this.$dataLocal.UserData().fleet_group_id
    let my_level = this.$dataLocal.UserData().fleet_group.levels
    axios.get(GET_PARAM_POWER_BY).then((res_param) => {
      let param_report = res_param.data.data.filter((x) => {
        if (self.isFuelConsumption == 1) {
          return x.name == 'GTA'
        } else {
          return x.name == 'GTA-FUEL'
        }
      })

      let embed_param = res_param.data.data.filter((x) => {
        if (self.isFuelConsumption == 1) {
          return x.name == 'GEA'
        } else {
          return x.name == 'GEA-FUEL'
        }
      })

      REPO.getReportMappingByFleet(
        this.$dataLocal.UserData().fleet_group_id
      ).then((res) => {
        if (res.data.status == 'true') {
          let tmp = res.data.data.data
          if (tmp.length > 0) {
            let hasil
            if (self.isFuelConsumption == 1) {
              hasil = tmp[0].report_mapping.filter((z) => {
                return (
                  z.power_bi.name == 'GEA' &&
                  z.report.name !=
                    'Vehicle Health Without Fuel Consumption (Web Analytic)'
                )
              })
            } else {
              hasil = tmp[0].report_mapping.filter((z) => {
                return (
                  z.power_bi.name == 'GEA' &&
                  z.report.name !=
                    'Vehicle Health With Fuel Consumption (Analytic Web)'
                )
              })
            }

            self.tabReport = hasil
            let param = {
              grant_type: 'client_credentials',
              client_id: 'b812d60e-2c1d-447f-894e-426d664603fe',
              client_secret: '?dVCtg70n]K[Nw1i.mSPbFS1CmY]AZ-2',
              resource: 'https://analysis.windows.net/powerbi/api',
            }
            REPO.loginMicrosoft(param).then((res) => {
              let tmp = JSON.parse(res.data.data)
              //
              let token = tmp.access_token
              let param = {
                accessLevel: 'View',
                identities: [
                  {
                    username: '4fb7aafe-2d7a-46d9-b5d9-057b51fe553b',
                    datasets: [param_report[0].datasets],
                  },
                ],
              }
              REPO.getAccessTokenAnalytics(
                param,
                token,
                param_report[0].url
              ).then((res2) => {
                var txtAccessToken = res2.data.token

                // var txtEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=d5244c04-7e53-41db-8b11-0f3f617b6c5d&groupId=9542965e-d501-472b-b76e-2262e3fc7b14&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCJ9&filterPaneEnabled=False&filter=DimFleetGroup/id in ('"+this.fleet_group_id+"')&DimMsVehicle/FleetGroupId in  ('"+this.fleet_group_id+"')";
                // var txtEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=d5244c04-7e53-41db-8b11-0f3f617b6c5d&groupId=9542965e-d501-472b-b76e-2262e3fc7b14&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCJ9&filterPaneEnabled=False&filter=DimFleetGroup/id in ("+fleet_str+")";
                // https://api.powerbi.com/v1.0/myorg/groups/91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c/reports/85f4bf9f-08ff-4292-83f7-f869510f9ee4
                // var txtEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=85f4bf9f-08ff-4292-83f7-f869510f9ee4&groupId=91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCJ9&filterPaneEnabled=False&filter=DimFleetGroup/id in ("+fleet_str+")";

                // var txtEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=537c1e6d-b730-49c6-bacb-0b7a6624e208&groupId=91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVNPVVRILUVBU1QtQVNJQS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCJ9&filterPaneEnabled=False&filter=DimFleetGroup/Level1FleetGroupId eq '"+self.fleet_group_id+"'";
                let { fleet_group_id } = self
                var txtEmbedUrl =
                  embed_param[0].url +
                  `&filterPaneEnabled=False&filter=DimFleetGroup/Level${my_level}FleetGroupId eq '${fleet_group_id}'`
                // var txtEmbedUrl = "https://app.powerbi.com/reportEmbed?reportId=537c1e6d-b730-49c6-bacb-0b7a6624e208&groupId=91a5ae0f-6fb1-45ad-bb09-64bcb002ba1c&filterPaneEnabled=False&$filter=DimFleetGroup/Level1FleetGroupId eq 'FE8238B0-A15A-11E9-99EE-BF0C04FCE207'";
                //

                var txtEmbedReportId = embed_param[0].report_id

                var models = pbi.models
                var permissions = models.Permissions.Read
                self.aktifBtn = hasil[0].report.param
                var config = {
                  type: 'report',
                  pageName: hasil[0].report.label,
                  pageId: hasil[0].report.param,
                  tokenType: models.TokenType.Embed,
                  accessToken: txtAccessToken,
                  embedUrl: txtEmbedUrl,
                  id: txtEmbedReportId,
                  pageView: 'fitToWidth',
                  permissions: permissions,
                  settings: {
                    filterPaneEnabled: false,
                    navContentPaneEnabled: false,
                  },
                }

                var embedContainer = document.querySelector('#embedContainer')
                //
                self.report = powerbi.embed(embedContainer, config)

                self.report.off('loaded')

                self.report.on('loaded', function () {
                  const page = self.report.page(hasil[0].report.param)
                  page.setActive()
                  //
                })

                self.report.off('rendered')

                self.report.on('rendered', function () {
                  //
                })

                self.report.on('error', function (event) {
                  //

                  report.off('error')
                })

                self.report.off('saved')
                self.report.on('saved', function (event) {
                  //
                  if (event.detail.saveAs) {
                  }
                })
              })
            })
          } else {
            alert('Report Not Setup yet for this fleet group !!!')
          }
        }
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.tbl-none {
  background: #cdd7de !important;
  color: black;
}

.tbl-active {
  background: #2574bc !important;
}
</style>
